import _ from 'lodash';

import * as types from './types';
import { Templates } from '../../helpers/Constants'
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
    productionReportSetup: {
      Data: [],
      Errors: [],
    },
    filteredData: [], 
    mealTypes: [],
    template: Templates.Simple,   
    details: '',
    otherDetails: '',
    reportNotes: '',
};

export default (state = INITIAL_STATE, action) => {   
    switch (action.type) {
        case types.PRODUCTION_REPORT_SETUP_GET_REPORTS:
            return {
                ...state,
                productionReportSetup: {
                    ...action.payload.data,
                    Data: action.payload.data.Data.Data.map(report => ({
                        ...report,                        
                        LastModifiedDate: report.LastModifiedDate
                        ? defaultDateFormat(report.LastModifiedDate)
                        : '',
                    })),
                },
            };

        case types.PRODUCTION_REPORT_SETUP_CLEAR_ERROR:
            return {
                ...state,
                fetchError: null,
            };

        case types.PRODUCTION_REPORT_SETUP_ERROR:
            return {
                ...state,
                fetchError: {
                    Title: action.payload
                            ? action.payload.Title
                            : 'Error',
                    Message: action.payload
                        ? action.payload.Message
                        : 'An error has occurred. Please try again',
                },
            };

        case types.PRODUCTION_REPORT_SETUP_MODAL_VISIBILITY:
            const { modal, show } = action.payload;        
            return { ...state, [modal]: show };   
            
        case types.PRODUCTION_REPORT_SETUP_CHANGE_PAGE:
            const { page } = action.payload;
            return { ...state, page };

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_SELECTED_TEMPLATE:
            const { template } = action.payload;
            return { ...state, template };

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_MEAL_TYPE:
            return { ...state, mealTypes: _.uniq([...state.mealTypes, action.payload.mealType]) };

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_MEAL_TYPES:
            return { ...state, mealTypes: action.payload.mealTypes };

        case types.PRODUCTION_REPORT_SETUP_MODAL_REMOVE_MEAL_TYPE:

            let ret = [...state.mealTypes];
            ret = _.pull(ret, action.payload.mealType);
            
            return { ...state, mealTypes: ret };        

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_OTHER_DETAILS:
            return { ...state, otherDetails: action.payload };

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_DETAILS:
            return { ...state, details: action.payload };

        case types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_NOTES:
            return { ...state, reportNotes: action.payload };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/state/reports/reducer.js